var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 317,
    viewBox: "0 0 424 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.305 182.896C159.002 228.7 132.957 268.787 85.6523 268.787C38.3479 268.787 0 230.332 0 182.896C0 135.46 49.8591 128.02 85.6523 97.0055C158.338 34.0246 209.511 40.6537 171.305 182.896Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.398 69.761C211.5 69.761 223.743 57.4844 223.743 42.3405C223.743 27.1966 211.5 14.92 196.398 14.92C181.296 14.92 169.054 27.1966 169.054 42.3405C169.054 57.4844 181.296 69.761 196.398 69.761Z",
    fill: "#C996CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.859 4.03242H231.383V18.5492H245.859V4.03242Z",
    fill: "#C996CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6969 278.289C124.452 278.289 155.058 274.113 155.058 268.963C155.058 263.812 124.452 259.637 86.6969 259.637C48.9422 259.637 18.3359 263.812 18.3359 268.963C18.3359 274.113 48.9422 278.289 86.6969 278.289Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.409 52.0183H105.92V99.1977H198.409V52.0183Z",
    fill: "#916BBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9992 255.253C100.544 255.253 114.767 240.99 114.767 223.396C114.767 205.803 100.544 191.54 82.9992 191.54C65.4544 191.54 51.2314 205.803 51.2314 223.396C51.2314 240.99 65.4544 255.253 82.9992 255.253Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1737 248.397H68.5227V265.737H78.1737V248.397Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4757 248.397H87.8247V265.737H97.4757V248.397Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5652 268.963C81.0069 268.963 84.6077 267.609 84.6077 265.939C84.6077 264.268 81.0069 262.914 76.5652 262.914C72.1234 262.914 68.5227 264.268 68.5227 265.939C68.5227 267.609 72.1234 268.963 76.5652 268.963Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8672 268.56C100.309 268.56 103.91 267.206 103.91 265.535C103.91 263.865 100.309 262.511 95.8672 262.511C91.4254 262.511 87.8247 263.865 87.8247 265.535C87.8247 267.206 91.4254 268.56 95.8672 268.56Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8034 226.219C89.7997 226.219 94.6607 221.345 94.6607 215.332C94.6607 209.319 89.7997 204.444 83.8034 204.444C77.807 204.444 72.946 209.319 72.946 215.332C72.946 221.345 77.807 226.219 83.8034 226.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8034 218.961C85.8022 218.961 87.4225 217.336 87.4225 215.332C87.4225 213.327 85.8022 211.702 83.8034 211.702C81.8047 211.702 80.1843 213.327 80.1843 215.332C80.1843 217.336 81.8047 218.961 83.8034 218.961Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1835 193.771C49.6184 182.251 57.818 170.611 70.4978 167.772C83.1777 164.933 95.5361 171.97 98.1012 183.49C100.666 195.009 92.2629 199.258 79.5831 202.097C66.9033 204.936 54.7486 205.291 52.1835 193.771Z",
    fill: "#916BBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1418 163.716C89.6866 163.716 103.91 149.454 103.91 131.86C103.91 114.267 89.6866 100.004 72.1418 100.004C54.5969 100.004 40.374 114.267 40.374 131.86C40.374 149.454 54.5969 163.716 72.1418 163.716Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3165 156.861H57.6655V174.201H67.3165V156.861Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6182 156.861H76.9673V174.201H86.6182V156.861Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.708 177.427C70.1497 177.427 73.7505 176.073 73.7505 174.402C73.7505 172.732 70.1497 171.378 65.708 171.378C61.2663 171.378 57.6655 172.732 57.6655 174.402C57.6655 176.073 61.2663 177.427 65.708 177.427Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0098 177.023C89.4515 177.023 93.0522 175.669 93.0522 173.999C93.0522 172.329 89.4515 170.975 85.0098 170.975C80.568 170.975 76.9673 172.329 76.9673 173.999C76.9673 175.669 80.568 177.023 85.0098 177.023Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9462 134.683C78.9425 134.683 83.8035 129.809 83.8035 123.795C83.8035 117.782 78.9425 112.908 72.9462 112.908C66.9499 112.908 62.0889 117.782 62.0889 123.795C62.0889 129.809 66.9499 134.683 72.9462 134.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9463 127.425C74.945 127.425 76.5654 125.8 76.5654 123.795C76.5654 121.791 74.945 120.166 72.9463 120.166C70.9475 120.166 69.3271 121.791 69.3271 123.795C69.3271 125.8 70.9475 127.425 72.9463 127.425Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3261 102.235C38.761 90.7153 46.9606 79.0752 59.6404 76.236C72.3202 73.3969 84.6787 80.4338 87.2438 91.9535C89.8089 103.473 81.4055 107.722 68.7257 110.561C56.0459 113.4 43.8912 113.755 41.3261 102.235Z",
    fill: "#916BBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.163 109.59C109.295 101.373 109.748 93.912 107.176 92.926C104.603 91.9401 99.979 97.802 96.847 106.019C93.715 114.236 93.2614 121.697 95.8338 122.683C98.4063 123.669 103.031 117.807 106.163 109.59Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7122 123.905C51.8923 121.409 46.4236 116.331 38.4975 112.561C30.5714 108.791 23.1893 107.758 22.0091 110.253C20.829 112.748 26.2977 117.827 34.2238 121.597C42.15 125.367 49.5321 126.4 50.7122 123.905Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5376 143.353C56.5376 146.471 64.5433 152.627 73.4268 152.627C82.3103 152.627 90.6395 143.85 90.6395 140.732C90.6395 137.614 82.3103 141.337 73.4268 141.337C64.5433 141.337 56.5376 140.235 56.5376 143.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.256 45.1632H114.767V92.3426H207.256V45.1632Z",
    stroke: "#3F3D56",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.685 0.403244H236.208V14.92H250.685V0.403244Z",
    stroke: "#3F3D56",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 217.871C424 250.867 404.439 262.388 380.308 262.388C356.178 262.388 336.617 250.867 336.617 217.871C336.617 184.875 380.308 142.898 380.308 142.898C380.308 142.898 424 184.875 424 217.871Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.717 257.341L379.164 229.726L397.787 195.562L379.234 225.394L379.436 212.977L392.27 188.26L379.489 209.691V209.691L379.851 187.359L393.594 167.681L379.908 183.847L380.134 142.898L378.713 197.107L378.83 194.871L364.857 173.423L378.606 199.164L377.304 224.105L377.265 223.443L361.156 200.873L377.216 225.782L377.053 228.901L377.024 228.948L377.038 229.204L373.735 292.482H378.148L378.677 259.798L394.698 234.95L378.717 257.341Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.611 296.994C384.002 296.994 390.803 294.974 390.803 292.481C390.803 289.988 384.002 287.967 375.611 287.967C367.221 287.967 360.42 289.988 360.42 292.481C360.42 294.974 367.221 296.994 375.611 296.994Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.463 317C345.218 317 375.824 312.825 375.824 307.674C375.824 302.524 345.218 298.348 307.463 298.348C269.708 298.348 239.102 302.524 239.102 307.674C239.102 312.825 269.708 317 307.463 317Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.267 291.746C325.812 291.746 340.035 277.484 340.035 259.89C340.035 242.296 325.812 228.034 308.267 228.034C290.722 228.034 276.499 242.296 276.499 259.89C276.499 277.484 290.722 291.746 308.267 291.746Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.092 302.23H322.743V284.891H313.092V302.23Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.791 302.23H303.442V284.891H293.791V302.23Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.113 306.664C301.96 304.437 304.403 301.459 303.571 300.013C302.738 298.566 298.944 299.199 295.098 301.426C291.251 303.653 288.808 306.631 289.641 308.077C290.473 309.524 294.267 308.891 298.113 306.664Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.013 306.664C320.86 304.437 323.303 301.459 322.47 300.013C321.637 298.566 317.844 299.199 313.997 301.426C310.151 303.653 307.707 306.631 308.54 308.077C309.373 309.524 313.166 308.891 317.013 306.664Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.463 262.713C313.459 262.713 318.32 257.838 318.32 251.825C318.32 245.812 313.459 240.938 307.463 240.938C301.466 240.938 296.605 245.812 296.605 251.825C296.605 257.838 301.466 262.713 307.463 262.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.765 250.817C305.764 250.817 307.384 249.192 307.384 247.188C307.384 245.183 305.764 243.559 303.765 243.559C301.766 243.559 300.146 245.183 300.146 247.188C300.146 249.192 301.766 250.817 303.765 250.817Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.083 230.265C341.648 218.745 333.448 207.105 320.768 204.266C308.089 201.426 295.73 208.463 293.165 219.983C290.6 231.503 299.003 235.751 311.683 238.59C324.363 241.43 336.518 241.784 339.083 230.265Z",
    fill: "#916BBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.037 255.207C296.12 252.668 290.461 247.804 282.396 244.342C274.331 240.881 266.915 240.133 265.831 242.672C264.748 245.211 270.407 250.075 278.472 253.536C286.537 256.998 293.953 257.745 295.037 255.207Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.551 276.579C355.634 274.04 349.975 269.176 341.91 265.714C333.845 262.253 326.429 261.505 325.346 264.044C324.262 266.583 329.921 271.447 337.986 274.908C346.051 278.369 353.467 279.117 354.551 276.579Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.183 229.848H254.706V244.365H269.183V229.848Z",
    fill: "#C996CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.902 204.041H239.425V218.558H253.902V204.041Z",
    stroke: "#3F3D56",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.622 273.802C314.622 275.727 313.86 277.573 312.502 278.934C311.145 280.295 309.304 281.06 307.384 281.06C305.465 281.06 303.623 280.295 302.266 278.934C300.909 277.573 300.146 275.727 300.146 273.802C300.146 269.793 303.387 268.963 307.384 268.963C311.382 268.963 314.622 269.793 314.622 273.802Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 317,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.ee4431e71137c40b19c0eb50f53ffcbe.svg";
export { ForwardRef as ReactComponent };